import React from "react";
import UploadFile from "./UploadId";
import { useSelector } from "react-redux";
import { IoMdAdd } from "react-icons/io";
import beImagePlaceHolder from "../../../../assets/images/svgs/beImagePlaceHolder.svg";
import { message } from "antd";
import { isFileSizeValid } from "../../utils";
import { RiDeleteBin6Line } from "react-icons/ri";
import { TranslateText } from "../../../../utils/translation";

const PhotosSection = ({
  imageTitle,
  title,
  imageArray = [],
  handleUpload,
  removeImage,
}) => {
  const { editHotelDetails } = useSelector((store) => store.usersRestriction);

  const handleImageBeforeUpload = async (file, fileSize) => {
    const fileSizeInKb = fileSize * 1000;

    if (
      !isFileSizeValid(
        file,
        fileSize,
        `File size must be smaller than ${fileSizeInKb} kb`
      )
    ) {
      message.error(`File size must be lesser than ${fileSizeInKb} kb`);
      return false;
    } else return true;
  };

  const defaultImageArray = [
    ...imageArray.slice(0, 4),
    ...new Array(4 - Math.min(imageArray.length, 4)).fill({}),
  ];

  return (
    <div>
      {" "}
      <div className="photosSection flex flex-col gap-[24px]">
        <div className="font-body font-[500] text-[24px] leading-[30.24px] text-fg">
          {title}
        </div>

        <div className="w-[100%] flex justify-between items-center gap-[24px] ">
          {defaultImageArray.map((image, index) => (
            <div
              key={index}
              className="flex flex-col gap-[24px] items-start justify-start w-[165px] h-[142px] relative rounded-[8px]"
            >
              {!image?.url ? (
                <div className="w-[100%] h-[100%] bg-surface-page border-[1px] border-brand-border-muted flex flex-col justify-center items-center rounded-[8px]">
                  <div className="w-[32px] h-[32px]">
                    <img
                      src={beImagePlaceHolder}
                      className="w-[100%] h-[100%]"
                      alt=""
                    />
                  </div>
                  <div className="font-body font-[400] text-[14px] leading-[21px] text-fg-placeholder">
                    
                    <TranslateText
                      textKey={"drag_and_drop_your_logo"}
                      namespace="profile"
                    /> 
                  </div>
                  <UploadFile
                    handleImageBeforeUpload={handleImageBeforeUpload}
                    handleUpload={(item) => handleUpload(item, imageTitle)}
                    fileSize={10}
                  >
                    <div className="font-body font-[400] text-[14px] leading-[21px] text-primary cursor-pointer">
                      
                      <TranslateText
                      textKey={"or_choose"}
                      namespace="profile"
                    /> 
                    </div>
                  </UploadFile>
                </div>
              ) : (
                <img
                  src={image?.url}
                  alt="rect"
                  id="viewer"
                  className="w-[100%] h-[100%] rounded-[8px]"
                />
              )}

              {editHotelDetails && image?.url && (
                <div
                  className="bg-surface w-[24px] h-[24px] rounded-[50%] flex justify-center items-center absolute top-[10px] right-[10px] z-[10] cursor-pointer"
                  onClick={() => removeImage(image?.url)}
                >
                  <RiDeleteBin6Line className="text-[12px] text-danger " />
                </div>
              )}
            </div>
          ))}

          <div className="h-[142px] w-[165px] rounded-[12px] border-[1px] bg-surface-page border-brand-border-muted flex flex-col justify-center items-center">
            <UploadFile
              handleImageBeforeUpload={handleImageBeforeUpload}
              handleUpload={(item) => handleUpload(item, imageTitle)}
              fileSize={10}
            >
              <div className="flex flex-col justify-center items-center cursor-pointer">
                <IoMdAdd className="text-fg-placeholder text-[18px]" />
                <span className=" font-body font-[400] text-[16px] leading-[24px] text-fg-placeholder">
                  {" "}
                  
                  <TranslateText
                      textKey={"add_more"}
                      namespace="profile"
                    /> 
                </span>{" "}
              </div>
            </UploadFile>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotosSection;
